import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import FeedPage from "@/pages/FeedPage";
import BrowsePage from "@/pages/BrowsePage";
import WorkoutPage from "@/pages/WorkoutPage";
import RecipePage from "@/pages/RecipePage";
import SubscriptionsPage from "@/pages/SubscriptionsPage";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import SupportPage from "@/pages/SupportPage";
import BillingPage from "@/pages/BillingPage";
import DemoPage from "@/pages/DemoPage";

const REF_KEY = "flexfeed_ref";

function ReferralCapture() {
    const location = useLocation();
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const code = params.get("ref");
        if (code) {
            try {
                localStorage.setItem(REF_KEY, code.trim().toUpperCase());
            } catch {}
        }
    }, [location.search]);
    return null;
}

function AppRouter() {
    const location = useLocation();
    // Synchronous: handle session_id in URL fragment BEFORE other routes
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <>
            <ReferralCapture />
            <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/payment/success" element={<PaymentSuccessPage />} />
                <Route path="/demo" element={<DemoPage />} />
                <Route
                    path="/*"
                    element={
                        <AppShell>
                            <Routes>
                                <Route path="/" element={<FeedPage />} />
                                <Route path="/browse" element={<BrowsePage />} />
                                <Route path="/workout/:id" element={<WorkoutPage />} />
                                <Route path="/recipe/:id" element={<RecipePage />} />
                                <Route path="/orders" element={<SubscriptionsPage />} />
                                <Route path="/support" element={<SupportPage />} />
                                <Route path="/billing" element={<BillingPage />} />
                            </Routes>
                        </AppShell>
                    }
                />
            </Routes>
        </>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <CartProvider>
                        <AppRouter />
                    </CartProvider>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
